export default __webpack_public_path__ + "static/media/were-at-disney.b661dfe6.png";